import { Tooltip } from '@percent/lemonade'
import styles from './TitleLink.module.scss'

export type TitleLinkProps = Readonly<{
  campaignHref: string
  campaignTitle: string
}>

export function TitleLink({ campaignHref, campaignTitle }: TitleLinkProps) {
  if (campaignTitle.length > 60) {
    return (
      <Tooltip content={campaignTitle}>
        <a className={styles.link} href={campaignHref} target="_blank" rel="noopener noreferrer">
          {campaignTitle.substring(0, 35)}...
        </a>
      </Tooltip>
    )
  }

  return (
    <a className={styles.link} href={campaignHref} target="_blank" rel="noopener noreferrer">
      {campaignTitle}
    </a>
  )
}
